export default __webpack_public_path__ + "static/media/building-profile.cb483742.svg";